export default (isCuttingEdge: boolean) => {
  return {
    isCuttingEdge: isCuttingEdge,
  };
};
